/**
 * Maps ObjectType module_tag values to hub route prefixes.
 *
 * When an OBJECT_REFERENCE field links to an ObjectType with a known
 * module_tag, clicking the value navigates to the hub detail page
 * instead of the generic MDM admin page.
 */

/** module_tag → hub route prefix (without trailing slash) */
const HUB_ROUTES = new Map<string, string>([
  ['supplier_quality:supplier', '/suppliers'],
  // Future: ['equipment:equipment', '/equipment'],
]);

type RouteOptions = {
  /** Query parameter to select a specific tab on the hub detail page. */
  tab?: string;
};

/**
 * Returns the detail page route for an ObjectRecord.
 *
 * If the ObjectType has a module_tag that maps to a known hub,
 * returns the hub route. Otherwise falls back to the MDM admin
 * detail page. Supports an optional `tab` query param for deep-linking
 * to a specific tab (e.g., `?tab=schedule`).
 */
export function getObjectRecordRoute(
  moduleTag: string | null | undefined,
  objectTypeId: string,
  recordId: string,
  options?: RouteOptions
): string {
  const hubPrefix = moduleTag ? HUB_ROUTES.get(moduleTag) : undefined;
  const suffix = options?.tab ? `?tab=${options.tab}` : '';

  if (hubPrefix) {
    return `${hubPrefix}/${recordId}${suffix}`;
  }

  return `/admin/master-data/object-types/${objectTypeId}/records/${recordId}`;
}
